import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white px-6 py-20 lg:px-8" data-id="element-115">
      <div className="mx-auto max-w-4xl rounded-3xl bg-brand-navy p-8 text-center text-white shadow-soft-lg md:p-12" data-id="element-116">
        <ShieldCheck className="mx-auto mb-6 h-16 w-16 text-brand-gold" data-id="element-117" />
        <h2 className="text-3xl font-extrabold md:text-4xl" data-id="element-118">
          Probalo durante 21 días
        </h2>
        <p className="mx-auto mt-5 max-w-3xl text-lg leading-relaxed text-white/80" data-id="element-119">
          Revisá el material. Usá un script. Probá una herramienta. Si no te
          sirve, pedí tu devolución.
        </p>
        <p className="mt-5 font-bold text-brand-gold" data-id="element-120">
          Te devolvemos el 100%. Sin preguntas ni vueltas.
        </p>
        <button onClick={scrollToPricing} className="mt-8 rounded-xl bg-brand-accent px-7 py-3.5 font-extrabold text-white transition hover:bg-blue-600" data-id="element-121">
          Entrá sin riesgo
        </button>
      </div>
    </section>;
}